import { useEffect, useState } from "react";
import Lenis from "lenis";
import { api } from "@/lib/api";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Products from "@/components/Products";
import ForHome from "@/components/ForHome";
import About from "@/components/About";
import CraftStandard from "@/components/CraftStandard";
import WhyUs from "@/components/WhyUs";
import Benefits from "@/components/Benefits";
import Testimonials from "@/components/Testimonials";
import Certifications from "@/components/Certifications";
import FAQ from "@/components/FAQ";
import QuoteForm from "@/components/QuoteForm";
import Footer from "@/components/Footer";

export default function Home() {
  const [products, setProducts] = useState([]);
  const [commodity, setCommodity] = useState("");

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  useEffect(() => {
    api.get("/products").then((res) => setProducts(res.data)).catch(() => {});
  }, []);

  const handleEnquire = (name) => {
    setCommodity(name);
    document.querySelector("#quote")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="bg-cream">
      <div className="grain-overlay" />
      <Navbar />
      <Hero />
      <Marquee />
      <Products products={products} onEnquire={handleEnquire} />
      <ForHome products={products} />
      <About />
      <CraftStandard />
      <WhyUs />
      <Benefits />
      <Testimonials />
      <Certifications />
      <FAQ />
      <QuoteForm products={products} commodity={commodity} setCommodity={setCommodity} />
      <Footer />
    </div>
  );
}
